import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/playstore.png")